import React from 'react';
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import useData from '../../hooks/useReviews/useData';

const EasyBarChart = () => {
    const [data, setData] = useData();

    /* "month": "Mar",
          "investment": 100000,
          "sell": 241,
          "revenue": 10401 */

    return (
<div>
    <h2>
        Bar Chart to see the state monthly
    </h2>
    <BarChart
      width={500}
      height={300}
      data={data}
      margin={{
        top: 20,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="month" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="sell" stackId="a" fill="#8884d8" />
      <Bar dataKey="revenue" stackId="a" fill="#82ca9d" />
      <Bar dataKey="investment" fill="#ffc658" />
    </BarChart>
</div>
    );
};

export default EasyBarChart;